import { PageLoadTypeDetector, UrlHandler } from '../host-page-tools';
import { IFrameInitMessage } from './iframe-init-messages';

export class IFrameInitService {
  constructor(private urlHandler: UrlHandler, private pageLoadTypeDetector: PageLoadTypeDetector) {}

  initFrame(urlParameter: string, handleMessageToFrame: (message: IFrameInitMessage) => void): void {
    const autostartRef = this.urlHandler.parseQuery(urlParameter);
    const hostRelativeRef = this.urlHandler.getResetRelativeReference(urlParameter);
    const isReload = this.pageLoadTypeDetector.isReload();
    handleMessageToFrame({
      action: 'init',
      hostRelativeRef,
      autostartRef,
      isReload
    });
  }
}
